export default __webpack_public_path__ + "static/media/undraw_authentication_re_svpt.60566715.png";